import { parseBatchDays } from './formationEnrollmentBundle';

/**
 * Client-side trainer schedule overlap check (parity with localStorageService.checkTrainerConflict).
 * @param {Array<object>} batches - formation batches (`daysJson` or `days` normalized)
 */
export function checkTrainerBatchConflict(
  batches,
  trainerId,
  days,
  startTime,
  endTime,
  startDate,
  endDate,
  excludeBatchId = null
) {
  const list = Array.isArray(batches) ? batches : [];

  const newStartDate = new Date(startDate);
  const newEndDate = new Date(endDate);

  return list.filter((batch) => {
    if (excludeBatchId && batch.id === excludeBatchId) return false;
    if (batch.trainerId !== trainerId) return false;
    if (batch.status !== 'active') return false;

    const batchDays = parseBatchDays(batch);
    const hasDayOverlap = batchDays.some((day) => days.includes(day));
    if (!hasDayOverlap) return false;

    const batchStart = batch.startTime;
    const batchEnd = batch.endTime;
    const hasTimeOverlap =
      (startTime >= batchStart && startTime < batchEnd) ||
      (endTime > batchStart && endTime <= batchEnd) ||
      (startTime <= batchStart && endTime >= batchEnd);
    if (!hasTimeOverlap) return false;

    const batchStartDate = new Date(batch.startDate);
    const batchEndDate = new Date(batch.endDate);
    const hasDatePeriodOverlap = newStartDate < batchEndDate && batchStartDate < newEndDate;
    return hasDatePeriodOverlap;
  });
}
